import React from "react";
import Productslider from "../Productslider";
import { man1, man2 } from "../../Constant/Index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Slide2 from "../Slide2";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import ReUse from "../../services/helpers/reUse";
import AppService from "../../services/appServices";
import { ProductDetailActions } from "../../redux/slices/productDetail.slice";
import {
  clearResponseMessageAfterDelay,
  errorMessage,
  successMessage,
} from "../../redux/slices/responseMessage.slice";
import { CartActions } from "../../redux/slices/cart.slice";
import { useState } from "react";
import { Rating } from "react-simple-star-rating";
import ProductVariations from "../../pages/Product/ProductVariations";
import ResponseMessage from "../ReUse/ResponseMessage";
import ProductReview from "../../pages/Product/ProductReview";
import { ProductDetailHook } from "../../Hooks/ProductDetailHook";
import ShareProduct from "../../pages/Product/ShareProduct";
import AccessControl from "../Auth/AccessControl";
import CustomButton from "../ReUse/Components/Button";
import swal from "sweetalert";
import Header from "../Header";
import Footer from "../Footer";
import MeasurementField from "../../pages/Product/MeasurementField";

const ProductCustomizeDetailContent = ({ data, currentIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    product_id,
    product_name,
    slug,
    seller_id,
    seller_name,
    rating,
    review_count,
    reviews,
    description,
    category_id,
    category_name,
    sub_category_id,
    sub_category_name,
    brand_id,
    brand_name,
    images,
    thumbnail,
    unit_price,
    purchase_price,
    discount,
    discount_type,
    current_stock,
    colors,
    attributes,
    choice_options,
    variations,
    moq_selling,
    country_name,
    admin_id,
    admin_name,
    measurements,
  } = data ?? {};

  const cart = useSelector((state) => state.persistedReducer.cart);
  const { cartData } = cart ?? {};

  const isLoginAuth = useSelector(
    (state) => state.persistedReducer.auth.authenticated
  );

  const currentUser = useSelector((state) => state.persistedReducer.auth.user);
  const location = useLocation();

  const { state } = location ?? {};
  const { productMeasurements, productId } = state ?? {};
  const [loading, setLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [shippingLoader, setShippingLoader] = useState(false);
  const [matchedVarient, setMatchedVarient] = useState({
    type: "",
    sku: "",
    qty: null,
    price: null,
  });

  const [shippingCharges, setShippingCharges] = useState([]);
  const [productShippingCharges, setProductShippingCharges] = useState(null);

  const [reveiwFeedback, setReveiwFeedback] = useState("");
  const [givenRating, setGivenRating] = useState(null);
  const [reveiwStatusMessage, setReveiwStatusMessage] = useState("");
  const [reveiwLoader, setReveiwLoader] = useState(false);

  // const [selectedVarientType, setSelectedVarientType] = useState(["Amethyst", "34"]);

  const selectedVariant = useSelector((state) => state.productDetail);

  const productDetailRedux = useSelector((state) => state.productDetail);
  const { counter } = productDetailRedux ?? {};

  const { selectedVariantType, selectedVariations } = selectedVariant ?? {};

  const { type, sku, qty, price } = matchedVarient ?? {};

  const [view, setView] = useState(false);

  function matchVarient() {
    const foundVarient = ReUse.foundRecord({
      data: variations,
      property: "type",
      target: selectedVariantType?.join("-"),
    });
    const { type, sku, qty, price } = foundVarient ?? {};

    setMatchedVarient({
      type: type,
      sku: sku,
      qty: parseInt(qty),
      price: parseInt(price),
    });
  }

  useEffect(() => {
    matchVarient();
  }, [selectedVariantType]);

  const customerAddProductWishlist = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (!isLoginAuth) {
      dispatch(errorMessage("Please Login To Use whishlist"));
      dispatch(clearResponseMessageAfterDelay());
      setReveiwLoader(false);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        product_id: product_id,
        product_type: "seller",
      };

      const apiResp = await AppService.customerAddProductWishlist(payload);
      const { message, response } = apiResp.data;
      setLoading(false);
      dispatch(successMessage(message));
      setTimeout(() => {
        // dispatch(successMessage("Navigating..."));
        setTimeout(() => {
          dispatch(successMessage(""));
          navigate("/wish-list");
        }, 1000);
      }, 1000);
    } catch (err) {
      setLoading(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
    }
  };

  const customerAddProductCart = async (e) => {
    e.preventDefault();

    setCartLoading(true);

    if (ReUse.isFound(cartData, product_id)) {
      setCartLoading(false);
      dispatch(errorMessage("Already In cart"));
      dispatch(clearResponseMessageAfterDelay());
      setCartLoading(false);
      return;
    }

    // if (!isLoginAuth) {
    //   setLoading(false);
    //   dispatch(errorMessage("Please Login To Use Cart"));
    //   dispatch(clearResponseMessageAfterDelay());
    //   setCartLoading(false);
    //   return;
    // }

    if (selectedVariantType?.length === 0) {
      dispatch(errorMessage("Please select variant"));
      dispatch(clearResponseMessageAfterDelay());
      setCartLoading(false);
      return;
    }

    if (selectedVariantType?.length < attributes?.length) {
      dispatch(errorMessage("Please select all variants"));
      dispatch(clearResponseMessageAfterDelay());
      setCartLoading(false);
      return;
    }

    if (counter === 0) {
      dispatch(errorMessage("Please select quantity"));
      dispatch(clearResponseMessageAfterDelay());
      setCartLoading(false);
      return;
    }

    try {
      const { price, qty, sku, type } = matchedVarient ?? {};

      const {
        brand_id,
        brand_name,
        category_id,
        category_name,
        current_stock,
        description,
        discount,
        discount_type,
        images,
        product_name,
        thumbnail,
        unit_price,
        product_id,
      } = data ?? {};

      const resultVariations = {};

      selectedVariations.forEach((variant) => {
        resultVariations[variant?.valueCategory] = variant?.selectedValue;
      });

      const payload = {
        brand_name,
        category_id,
        category_name,
        current_stock,
        description,
        discount,
        discount_type,
        images,
        product_id,
        product_name,
        thumbnail,
        unit_price: price,
        qty: counter,
        currentStock: qty,
        calculatedPrice: ReUse.calculateSubtotalPrice(
          price || unit_price,
          counter
        ),
        shippingCharges: productShippingCharges,
        variant: selectedVariantType?.join("-"),
        variations: resultVariations,
        product_type: "customizable",
      };

      dispatch(CartActions.Add_To_Cart(payload));
      dispatch(successMessage("Added to cart"));
      setCartLoading(false);
      dispatch(ProductDetailActions.setClearVariants());
      setTimeout(() => {
        // dispatch(successMessage("Navigating..."));
        setTimeout(() => {
          dispatch(successMessage(""));
          navigate("/cart");
        }, 1000);
      }, 1000);
    } catch (err) {
      setCartLoading(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
    }
  };

  const clearVariants = () => {
    dispatch(ProductDetailActions.setClearVariants());
  };

  useEffect(() => {
    const apiShippingCharges = AppService.shippingCharges();
    ReUse.getApiData(apiShippingCharges, setShippingCharges, setShippingLoader);
  }, []);

  useEffect(() => {
    const { country } = currentUser ?? {};
    let foundCharges = 0;
    let shippingType = "";

    if (country?.toLowerCase() === country_name?.toLowerCase()) {
      shippingType = "same-country";
    } else {
      shippingType = "different-country";
    }

    foundCharges = shippingCharges.find(
      (record) => record?.shipping_type === shippingType
    );
    setProductShippingCharges(parseInt(foundCharges?.charges || 0));
  }, [country_name, currentUser, shippingCharges]);

  const response = useSelector((state) => state.responseMessage);

  const productDetailHook = ProductDetailHook(qty, selectedVariations);
  const [measurement, setMeasurement] = useState({});

  const handleIncrement = () => {
    productDetailHook.handleIncrement();
  };

  const handleDecrement = () => {
    productDetailHook.handleDecrement();
  };

  const navigateToGetQuote = () => {
    navigate("/get-quote", {
      state: { productMeasurements: measurements, productId: product_id },
    });
  };

  const navigateCustomizeDesign = () => {
    navigate("/customize-design", {
      state: { productMeasurements: measurements, productId: slug },
    });
  };

  const ClearSelectionComponent = () => {
    return (
      selectedVariations?.length > 0 && (
        // <p onClick={() => clearVariants()}>Clear Selections</p>
        <button className="clear-sec-btn" onClick={() => clearVariants()}>
          Clear Selections
        </button>
      )
    );
  };

  const productsliderProps = {
    catId: category_id,
    subCatId: sub_category_id,
  };

  const reveiwSubmitHandler = async (e) => {
    e.preventDefault();

    setReveiwLoader(true);

    if (!isLoginAuth) {
      swal("Sorry!", "Please Login First!", "error");
      // dispatch(errorMessage("Please Login for Review"));
      dispatch(clearResponseMessageAfterDelay());
      setReveiwLoader(false);

      return;
    } else if (!givenRating) {
      setReveiwLoader(false);
      dispatch(errorMessage("Add Rating"));
      dispatch(clearResponseMessageAfterDelay());

      return;
    }

    if (!reveiwFeedback) {
      setReveiwLoader(false);
      dispatch(errorMessage("Add Feeback"));
      dispatch(clearResponseMessageAfterDelay());
      return;
    }

    try {
      const payload = {
        product_id: product_id,
        comment: reveiwFeedback,
        rating: givenRating,
      };

      const apiResp = await AppService.customerCustomizableSubmitReview(
        payload
      );
      const { message, response } = apiResp.data;
      setReveiwLoader(false);
      swal("Congragulations!", "You clicked the button!", "success");
      // dispatch(successMessage(message));
      // setTimeout(() => {
      //   dispatch(successMessage("Processing feedback."));
      //   setTimeout(() => {
      //     dispatch(successMessage(""));
      //   }, 1000);
      // }, 1000);
    } catch (err) {
      setReveiwLoader(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
      dispatch(successMessage(""));
    }
  };
  const handleRating = (rating) => {
    setGivenRating(rating);
  };
  const measurementFieldProps = {
    productMeasurements,
    setMeasurement,
    measurement,
  };
  const generateId = ReUse.makeId();

  const MeasurementFieldComponent = () => {
    return (
      <>
        {productMeasurements?.map((currentMeasurement, i) => (
          <MeasurementField
            key={generateId}
            measurementFieldProps={{
              ...measurementFieldProps,
              currentMeasurement,
              currentIndex: i,
            }}
          />
        ))}
      </>
    );
  };
  return (
    <>
      <Header />
      <section className="product-detail-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 only-for-this-product">
              <Slide2 images={images} thumbnail={thumbnail} />
            </div>
            <div className="col-md-6">
              <div className="custom-fashion-text">
                <h3>{product_name}</h3>
                <div className="name-stars">
                  <Rating
                    size={20}
                    allowFraction={true}
                    initialValue={rating}
                    readonly={true}
                  />
                  <p>{`( ${review_count} ) Customer Review`}</p>
                </div>
                <div className="seller">
                  <p>{ReUse.removeHTMLTags({ unStripped: description })}</p>
                  <div className="seller-price">
                    <h2>
                      $
                      {ReUse.calculateSubtotalPrice({
                        unitPrice: price || unit_price,
                        quantity: counter,
                      })}
                      <span className="pieces-seller-price">/pieces</span>{" "}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="quantity">
                <div className="quantity-head">
                  <h5>Quantity</h5>
                </div>
                <div className="quantity-all-stuff">
                  <input value={counter} min="0" />
                  <button className="btn-qunatity-1" onClick={handleIncrement}>
                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                  </button>
                  <button className="btn-qunatity-2" onClick={handleDecrement}>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              {ReUse.mapItems(false, attributes, ProductVariations)}
              <ClearSelectionComponent />

              {/* {view ? <MeasurementFieldComponent /> : null} */}

              <div className="whishlist-and-cart-button">
                {/* <AccessControl
                  allowedRoles={["customer"]}
                  isMessageDisplay={false}
                  buttonMessage="Login to use Cart"
                //   buttonClassName="button"
                > */}

                {/* <button onClick={() => setView(true)}>open</button> */}

                <div className="whishlist-cart">
                  <CustomButton
                    loading={loading}
                    onClickHandler={customerAddProductWishlist}
                    customClassName="button"
                  >
                    Add to wishlist
                  </CustomButton>
                </div>
                {/* </AccessControl> */}
                {/* <AccessControl
                  allowedRoles={["customer"]}
                  isMessageDisplay={false}
                  buttonMessage="Login to use whishlist"
                //   buttonClassName="button"
                > */}
                <div className="whishlist-cart">
                  <CustomButton
                    loading={cartLoading}
                    onClickHandler={customerAddProductCart}
                    customClassName="button"
                  >
                    Add to Cart
                  </CustomButton>
                </div>
                {/* </AccessControl> */}

                {/* <AccessControl
                  allowedRoles={["customer"]}
                  isMessageDisplay={false}
                  buttonMessage="Login to use quote"
                //   buttonClassName="button"
                > */}
                <div className="whishlist-cart">
                  <button className="button" onClick={navigateToGetQuote}>
                    Get A Quote
                  </button>
                </div>
                {/* </AccessControl> */}

                {/* <AccessControl
                  allowedRoles={["customer"]}
                  isMessageDisplay={false}
                  buttonMessage="Login to use customize design"
                //   buttonClassName="button"
                > */}
                <div className="whishlist-cart">
                  <button className="button" onClick={navigateCustomizeDesign}>
                    Customize Design
                  </button>
                </div>
                {/* </AccessControl> */}
              </div>

              <ResponseMessage />

              <div className="category-text">
                <h5>
                  CATEGORIES: <span>{category_name}</span>
                </h5>
              </div>

              <div className="product-ul">
                <div className="product-head">
                  <h5>SHARE THIS PRODUCT:</h5>
                </div>
                <div className="product-ul">
                  <ShareProduct />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="reviews-tab-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="tabs-alls">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      description
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      reviews{" "}
                      <span className="for-number">{`(${review_count})`}</span>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#customer-write-reveiw"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      Write Reveiw{" "}
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="description-para">
                      <p>{ReUse.removeHTMLTags({ unStripped: description })}</p>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="reviews-all">
                      {ReUse.mapItems(false, reviews, ProductReview)}
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="customer-write-reveiw"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    {/* <AccessControl
                      allowedRoles={["customer"]}
                      isMessageDisplay={false}
                      buttonMessage="Login to send Reveiw"
                    > */}
                    <div class="modal-content">
                      <div class="modal-body">
                        <div className="review-modal-all">
                          <div className="reviews-modal-para">
                            <p>Write a Review</p>
                          </div>

                          <div className="reviews-modal-text">
                            <Rating
                              size={20}
                              allowFraction={true}
                              readonly={false}
                              onClick={handleRating}
                              className="mb-3"
                            />
                            <textarea
                              class="form-control"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              placeholder="Add feedback"
                              name="feedback"
                              onChange={(e) =>
                                setReveiwFeedback(e.target.value)
                              }
                              value={reveiwFeedback}
                            ></textarea>
                            <ResponseMessage />
                          </div>
                        </div>
                      </div>

                      <div className="all-seller-btn modal-submit-btn">
                        <CustomButton
                          loading={reveiwLoader}
                          onClickHandler={reveiwSubmitHandler}
                          customClassName="custom-btn"
                        >
                          Submit
                        </CustomButton>

                        {/* <ResponseMessage /> */}
                      </div>
                    </div>
                    {/* </AccessControl> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Productslider productsliderProps={productsliderProps} />
      <Footer />
    </>
  );
};

export default ProductCustomizeDetailContent;
